import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { AnimatePresence } from "framer-motion";
import { Menu, Trash2 } from "lucide-react";
import { useState } from "react";
import { APIKey } from "../../types/app.type";
import RevokeAPIKey from "./RevokeAPIKey";

interface Props {
  apiKey: APIKey;
}

function APIKeyActions({ apiKey }: Props) {
  const [openRevoke, setOpenRevoke] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon">
            <Menu size={14} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="right" align="start">
          <DropdownMenuItem
            onClick={() => setOpenRevoke(true)}
            className="gap-2 cursor-pointer"
            destructive
          >
            <Trash2 size={14} /> Revoke API Key
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <AnimatePresence>
        {openRevoke && <RevokeAPIKey apiKey={apiKey} setOpen={setOpenRevoke} />}
      </AnimatePresence>
    </>
  );
}

export default APIKeyActions;
